import { useTranslations } from 'next-intl';

import { H3 } from '@/components/shared/Typography';
import { T_PredictionWinnerModalType } from '@/ts/types/T_PredictionWinnerModalType';

interface I_ProfilePredictionDialogHeaderProps {
  type?: T_PredictionWinnerModalType;
  tokenSymbol?: string;
  shortName?: string;
}

export const ProfilePredictionDialogHeader = ({
  type,
  tokenSymbol,
  shortName
}: I_ProfilePredictionDialogHeaderProps) => {
  const t = useTranslations();

  const displayName = shortName || tokenSymbol;

  let title: string;
  if (type === 'missed') {
    title = t('profile.predictionWinners.missedPredictionsTitle');
  } else if ((type === 'ongoing' || type === 'resolving') && displayName) {
    title = `${displayName} ${t('profile.transferHistory.predictions')}`;
  } else {
    title = t('profile.predictionWinners.title');
  }

  return (
    <div className="pt-6 pb-5 border-b border-base-border/20 mb-4">
      <H3 className="text-foreground pl-5">{title}</H3>
    </div>
  );
};
